import { create } from "zustand";

interface Artifact {
  id: string;
  messageId: string;
  content: any;
  isLoading?: boolean;
  type?: string;
  parentId?: string;
}

interface ArtifactStore {
  artifacts: Artifact[];
  addArtifact: (artifact: Artifact) => void;
  clearArtifacts: () => void;
  getAllArtifacts: () => Artifact[];
}

export const useArtifactStore = create<ArtifactStore>((set, get) => ({
  artifacts: [],
  addArtifact: (artifact: Artifact) => {
    set((state) => ({
      artifacts: [...state.artifacts, artifact],
    }));
  },
  clearArtifacts: () => {
    set({ artifacts: [] });
  },
  getAllArtifacts: () => {
    return get().artifacts;
  },
}));
